import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Account from "./Component/Account";
import About from "./Component/About";
import CartPage from "./Component/CartPage";
import { CartProvider } from "./Component/CartContext";
import CheckOut from "./Component/CheckOut";
import Contact from "./Component/Contact";
import Delivery from "./Component/Delivery";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import Main from "./Component/Main";
import NotFound from "./Component/NotFound";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import Returns from "./Component/Returns";
import ScrollToTop from "./Component/ScrollToTop";
import Shop from "./Component/Shop";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Cookies from "./Component/Cookies";
import Faqs from "./Component/Faqs";
import PaymentStatus from "./Component/PaymentStatus";
import CommercePolicy from "./Component/CommercePolicies";
import PolicyCenter from "./Component/PolicyCenter";

function App() {
  return (
    <CartProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <a className="skip-link" href="#main-content">Skip to content</a>
        <Header />
        <div id="main-content">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/cart" element={<Navigate to="/cartpage" replace />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
            <Route path="/payment" element={<PaymentStatus />} />
            <Route path="/about" element={<About />} />
            <Route path="/account" element={<Account />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/policies" element={<PolicyCenter />} />
            <Route path="/orders" element={<CommercePolicy policy="orders" />} />
            <Route path="/payments" element={<CommercePolicy policy="payments" />} />
            <Route path="/product-information" element={<CommercePolicy policy="products" />} />
            <Route path="/food-safety" element={<CommercePolicy policy="foodSafety" />} />
            <Route path="/international-orders" element={<CommercePolicy policy="international" />} />
            <Route path="/promotions" element={<CommercePolicy policy="promotions" />} />
            <Route path="/data-rights" element={<CommercePolicy policy="dataRights" />} />
            <Route path="/account-policy" element={<CommercePolicy policy="account" />} />
            <Route path="/security" element={<CommercePolicy policy="security" />} />
            <Route path="/acceptable-use" element={<CommercePolicy policy="acceptableUse" />} />
            <Route path="/intellectual-property" element={<CommercePolicy policy="intellectualProperty" />} />
            <Route path="/accessibility" element={<CommercePolicy policy="accessibility" />} />
            <Route path="/complaints" element={<CommercePolicy policy="complaints" />} />
            <Route path="/disclaimer" element={<CommercePolicy policy="disclaimer" />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
